<template>
  <div v-if="data.length > 0" class="c-table">
    <edit-table :option="tableOption" :loading="loading" :data="data">
      <template slot="menu" scope="{row}">
        <feather-icon
          v-if="option.detail"
          icon="SearchIcon"
          class="text-primary cursor-pointer mr-1"
          size="20"
          @click="handleDetail(row)"
        />
        <feather-icon
          v-if="option.assessment"
          icon="FileTextIcon"
          class="text-primary cursor-pointer mr-1"
          size="20"
          @click="handleAssessment(row)"
        />
      </template>
    </edit-table>

    <b-modal
      v-model="detailShow"
      body-class="process-modal"
      size="xl"
      centered
      title="View"
      hide-footer
    >
      <staff-view
        v-if="formId && formId == 5"
        :id="currentData.staffId"
        :disabled="true"
      />
      <staff-view v-else :id="currentData.id" :disabled="true" />
    </b-modal>

    <b-modal
      v-model="assessmentShow"
      body-class="process-modal"
      size="xl"
      centered
      title="View"
      hide-footer
    >
      <assessment-view
        :id="currentData.id"
        :staff-id="currentData.id"
        :positivehow="false"
      />
    </b-modal>
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import { staff } from '@/api/staff/index'
import positiveRecordApi from '@/api/staff/positiveRecord/index'

export default {
  components: {
    EditTable,
    StaffView: () => import('@/views/staff/components/formEdit.vue'),
    AssessmentView: () =>
      import('@/views/staff/positiveRecord/components/view.vue'),
  },
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['formId', 'viewPageData'],
  data() {
    return {
      data: [],
      loading: false,
      detailShow: false,
      assessmentShow: false,
      currentData: {},
    }
  },
  computed: {
    tableOption() {
      const menuShow = this.option.detail || this.option.assessment
      const option = {
        refresh: false,
        header: false,
        menu: menuShow || false,
        editBtn: false,
        delBtn: false,
        disabled: true,
        columns: [
          {
            label: this.i18n('label.enName'),
            field: this.formId === 5 ? 'staffName' : 'enName',
          },
          { label: this.i18n('labelEmployment.staffNo'), field: 'staffNo' },
          {
            label: this.i18n('labelEmployment.deptId'),
            field: 'deptId',
            dictField: 'deptName',
          },
          {
            label: this.i18n('labelEmployment.jobTitle'),
            field: 'jobTitleName',
            // dictField: 'postName',
          },
          {
            label: 'Type',
            field: 'typeName',
            hide: this.formId !== 5,
          },
        ],
      }
      return option
    },
  },
  watch: {
    ids: {
      handler(e, o = []) {
        // console.log(e, o);
        let idsNew = e
        let idsOld = o
        if (e instanceof Array) {
          idsNew = e.join()
        }
        if (o instanceof Array) {
          idsOld = o.join()
        }
        if (idsNew !== idsOld) {
          if (e > 0) {
            this.onload(idsNew)
          }
        } else if (e.length > 0) {
          this.onload(idsNew)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    onload(ids) {
      if (!ids) {
        return
      }
      if (
        this.formId &&
        this.formId === 5 &&
        this.viewPageData &&
        this.viewPageData.positiveRecordIds
      ) {
        this.loading = true
        positiveRecordApi
          .getByIds({ ids: this.viewPageData.positiveRecordIds })
          .then((res) => {
            console.log(res, 'sssssssssss')
            const { data } = res.data

            this.data = data

            this.loading = false
          })
      } else {
        staff.easyList(1, -1, { ids }).then((res) => {
          const { data } = res.data
          this.data = data.records
          this.loading = false
        })
      }
      console.log(positiveRecordApi, 'getByIdsgetByIdsgetByIds')
    },
    handleDetail(e) {
      this.currentData = e.item
      this.detailShow = true
      console.log(e, 'handleDetail')
    },
    handleAssessment(e) {
      this.currentData = e.item
      this.assessmentShow = true
      console.log(e, 'handleAssessment')
    },
  },
}
</script>

<style lang="scss">
.c-table {
  .edit-table {
    table {
      td,
      th {
        line-height: 18px;
      }
      .width-200 {
        width: 200px;
      }
    }
  }
}
</style>
